import { lazy, Suspense, useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import {HeaderProvider} from "./utils/HeaderContext";

const HomePage = lazy(() => import("./pages/home"));
const ProductsPage = lazy(() => import("./pages/products"));
const ProductsIdPage = lazy(() => import("./pages/products/_id"));
const ContactPage = lazy(() => import("./pages/contact"));
const FaqPage = lazy(() => import("./pages/faq"));
const AboutPage = lazy(() => import("./pages/about"));
const CartPage = lazy(() => import("./pages/cart"));
const CheckoutPage = lazy(() => import("./pages/checkout"));
const PoliciesPage = lazy(() => import("./pages/policies"));
const ErrorPage = lazy(() => import("./components/templates/ErrorPage/ErrorPage"));

const createRouter = () => createBrowserRouter([
  // General layout
  { path: "/", element: suspenseComponent(HomePage), errorElement: <ErrorPage/> },
  // This url is redirect from spring boot app
  { path: "products", element: suspenseComponent(ProductsPage), errorElement: <ErrorPage/> },
  { path: "products/:id", element: suspenseComponent(ProductsIdPage), errorElement: <ErrorPage/> },
  { path: "contact", element: suspenseComponent(ContactPage), errorElement: <ErrorPage/> },
  { path: "faq", element: suspenseComponent(FaqPage), errorElement: <ErrorPage/> },
  { path: "about", element: suspenseComponent(AboutPage), errorElement: <ErrorPage/> },
  { path: "cart", element: suspenseComponent(CartPage), errorElement: <ErrorPage/> },
  { path: "policies", element: suspenseComponent(PoliciesPage), errorElement: <ErrorPage/> },
  // Checkout layout
  { path: "checkout", element: suspenseComponent(CheckoutPage), errorElement: <ErrorPage/> },
]);

function App() {
  const router = useMemo(createRouter, []);

  return (
    <HeaderProvider>
      <RouterProvider router={router} />
    </HeaderProvider>
  );
}

export default App;

const suspenseComponent = (Page) => {
  return (
    <Suspense fallback={<p>Loading...</p>}>
      <Page/>
    </Suspense>
  );
};

